<template>
    <header class="content__title">
        <h1>
            <div :class="['ini-icon','ini-icon--'+icon]"></div>
            <span v-html="title"></span>
        </h1>
    </header>
</template>

<script>
    export default {
        props: {
            title: String,
            icon: String
        }
    }
</script><style lang="scss">@import "@/assets/scss/components/_contenttitle.scss";</style>